import { defineComponent as _defineComponent } from 'vue'
import { User } from '@/interfaces/vuex/user';
import { ref, watch } from 'vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDeleteDialog',
  props: {
    value: { type: Boolean },
    user: null
  },
  emits: ["input", "delete"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'delete', email: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  user?: User;
};





const localValue = ref(props.value);

watch(
  () => props.value,
  (newValue) => {
    localValue.value = newValue;
  }
);

const closeDialog = () => {
  emit('input', false);
};

const handleDeleteClick = async () => {
  if (!props.user) {
    throw new Error('User is required');
  }
  emit('delete', props.user.email);
  closeDialog();
};

return { __sfc: true,props, emit, localValue, closeDialog, handleDeleteClick, BaseFormCard, sharedMessages }
}

})